export enum CheckBoxTypes {
  DEFAULT = 'DEFAULT',
  NOTIFICATION = 'NOTIFICATION',
  WITH_TEXT = 'WITH_TEXT',
  ROUNDED = 'ROUNDED',
  WITH_TEXT_NO_PADDING = 'WITH_TEXT_NO_PADDING',
  CHECK_LIST = 'CHECK_LIST',
  FORM_HORIZONTAL = 'FORM_HORIZONTAL',
}

export interface CheckboxProps {
  type?: CheckBoxTypes
  isChecked: boolean
  onPress?: () => void
  disabled?: boolean
  size?: number
  color?: string
  touched?: boolean
  fieldName?: string
  setFieldValue?: (field: string, value: boolean) => void
  title?: string
  textColor?: string
  showCompleteText?: boolean
}
